import React from 'react';
import { connect } from 'react-redux';
import SingleCart from './SingleCart/SingleCart';

const Cart = ({ cart }) => {
  const cartCount = cart.reduce((prev, curr) => {
    console.log('prev', prev, curr.quantity);
    return prev + curr.quantity;
  }, 0);
  const totalPrice = cart.reduce((prev, curr) => {
    return prev + curr.quantity * curr.price;
  }, 0);
  // const [cartCount, setCartCount] = useState(0);
  // const [totalPrice, setTotalPrice] = useState(0);

  // useEffect(() => {
  //   let price = 0;
  //   let count = 0;
  //   cart.forEach((item) => {
  //     count += item.quantity;
  //     price += item.quantity * item.price;
  //   });
  //   setCartCount(count);
  //   setTotalPrice(price);
  // }, [cart]);

  return (
    <div class="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-5 xxl:col-span-5">
      <div class="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
        {/* singleCart */}

        {cart.map((item) => (
          <SingleCart ItemData={item} key={item.id} />
        ))}

        {/* <div class="flex justify-between border-b-2 mb-2">
          <div class="text-lg py-2">
            <p>Dell E1916HV 18.5 Inch</p>
          </div>
          <div class="text-lg py-2">
            <div class="flex flex-row space-x-2 w-full items-center rounded-lg">
              <button class="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M18 12H6"
                  />
                </svg>
              </button>
              <p>0</p>
              <button class="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div class="flex justify-between border-b-2 mb-2">
          <div class="text-lg py-2">
            <p>Canon Eos 4000D 18MP</p>
          </div>
          <div class="text-lg py-2">
            <div class="flex flex-row space-x-2 w-full items-center rounded-lg">
              <button class="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M18 12H6"
                  />
                </svg>
              </button>
              <p>0</p>
              <button class="focus:outline-none bg-purple-700 hover:bg-purple-800 text-white font-bold py-1 px-1 rounded-full inline-flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div> */}

        <div class="flex justify-center items-center text-center">
          <div class="text-xl font-semibold">
            <p>Total Item</p>
            <p class="text-5xl">{cartCount}</p>
          </div>
        </div>
      </div>
      <div class="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4">
        <div class="flex justify-center items-center text-center">
          <div class="text-xl font-semibold">
            <p>Total Price</p>
            <p class="text-5xl">{totalPrice}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    cart: state.shop.cart,
  };
};

export default connect(mapStateToProps)(Cart);
